import { IShipmentLocationWithFullAddress } from '@ordersnproducts/modules/shared/services/shipment-location-with-address';

export const LOCATION_COLOR_TAG_VARIANT = 'info';
export const LOCATION_COLOR_TAG_ICON = 'pin-current-location';

export function getOptionWithAddress(
  location: IShipmentLocationWithFullAddress,
  showFullAddress = false,
  showMultipleLocations = false,
) {
  if (!location.locationAddress) {
    return location;
  }
  if (!showFullAddress && !showMultipleLocations) {
    return location;
  }
  const { isVariousLocation, locationAddress } = location;
  return {
    ...location,
    secondaryText: isVariousLocation ? null : locationAddress.formattedAddress,
    colorTag: isVariousLocation ? LOCATION_COLOR_TAG_VARIANT : null,
    colorTagText: location.isVariousLocation ? 'views.select_multiple_locations' : null,
    colorTagIcon: isVariousLocation ? LOCATION_COLOR_TAG_ICON : null,
  };
}
